import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {lowerCaseAllWordsExceptFirstLetter} from 'ferries/helpers/common';

const PortSuggetion = ({
  locationAbbr, locationName, locationCountry, isMetropolitan, hasParrent, isMatch, isLast, onClickPort
}) => {
  const portName = lowerCaseAllWordsExceptFirstLetter(locationName);
  const portClasses = classnames('d-block position-relative px-3', {
    'font-bold': isMetropolitan || isMatch,
    'pl-5': hasParrent,
    'border-bottom': isLast
  });

  return (
    <div
      className={portClasses}
      style={{padding: '12px'}}
      onClick={() => onClickPort(locationAbbr, locationName)}
    >
      {!isMetropolitan && <i className="icon icon-anchor mr-2" />}
      {`${portName}, ${locationCountry}`}
    </div>
  );
};

PortSuggetion.propTypes = {
  locationAbbr: PropTypes.string.isRequired,
  locationName: PropTypes.string.isRequired,
  locationCountry: PropTypes.string.isRequired,
  isMetropolitan: PropTypes.bool.isRequired,
  hasParrent: PropTypes.bool,
  isMatch: PropTypes.bool,
  isLast: PropTypes.bool,
  popularPortClass: PropTypes.string,
  onClickPort: PropTypes.func.isRequired
};

export default PortSuggetion;
